import { Fab } from "@mui/material";
import { PropTypes } from "prop-types";
import { useState } from "react";
import "./sidebar.scss";

const propTypes = {
  displayMobile: PropTypes.bool,
  fabIcon: PropTypes.node,
  fabLabel: PropTypes.string,
  children: PropTypes.node.isRequired,
};

const defaultProps = {
  displayMobile: false,
  fabIcon: "",
  fabLabel: "",
};

const Sidebar = ({ displayMobile, fabIcon, fabLabel, children }) => {
  const [displayMobileContent, setDisplayMobileContent] = useState(false);

  return (
    <>
      {displayMobile && (
        <div
          className={
            displayMobileContent ? "sidebar-mobile-content" : "fab-only"
          }
        >
          <div className="content">{children}</div>
          <Fab
            className="fab"
            size="medium"
            color="secondary"
            variant="extended"
            onClick={() => setDisplayMobileContent(!displayMobileContent)}
          >
            {displayMobileContent ? "" : fabIcon}
            {displayMobileContent ? "Done" : fabLabel}
          </Fab>
        </div>
      )}
      <div className="sidebar">{children}</div>
    </>
  );
};

Sidebar.defaultProps = defaultProps;
Sidebar.propTypes = propTypes;

export default Sidebar;
